import * as tslib_1 from "tslib";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { PieChart } from 'react-chartkick';
import { BoardyCard } from 'src/components/BoardyCard';
import { UserTable } from './UserTable';
import { ProjectList } from './ProjectList';
import { TaskStatus } from 'src/models/TaskStatus';
import { SprintChooser } from 'src/layout/SprintChooser';
import { StatisticTaskTable } from 'src/pages/statistics/StatisticTaskTable';
import Main from 'src/layout/Main';
var Summary = /** @class */ (function (_super) {
    tslib_1.__extends(Summary, _super);
    function Summary(props) {
        var _this = _super.call(this, props) || this;
        _this.load = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.props.projectStore.clear();
                        return [4 /*yield*/, this.props.projectStore.loadProjects(this.props.taskStore.sprintIndex)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleProjectSelection = function (project) {
            _this.setState({ projectName: project.name }, function () { return _this.loadStatistics(project.id); });
        };
        _this.handleUserSelection = function (user) {
            _this.setState({
                userName: user.user.name
            });
            _this.props.projectStore.selectedUserSummary = user;
        };
        _this.state = {
            projectName: null,
            userName: null
        };
        return _this;
    }
    Summary.prototype.componentWillMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.load()];
                    case 1:
                        _a.sent();
                        this.props.taskStore.sprintChanged.subscribe(this.load);
                        return [2 /*return*/];
                }
            });
        });
    };
    Summary.prototype.componentWillUnmount = function () {
        this.props.taskStore.sprintChanged.unsubscribe(this.load);
    };
    Summary.prototype.render = function () {
        var _this = this;
        var store = this.props.projectStore;
        var projectChooser = !store.hasProject ? null :
            React.createElement(BoardyCard, { title: "Projektek" },
                React.createElement(ProjectList, { items: store.projects, onSelection: this.handleProjectSelection }));
        var taskChart = !store.hasStatistics ? null :
            React.createElement(BoardyCard, { title: this.state.projectName + " (Feladatok)" },
                React.createElement(PieChart, { data: store.projectStatistics.taskChartData, colors: TaskStatus.getPalette() }));
        var userChart = !store.hasStatistics ? null :
            React.createElement(BoardyCard, { title: this.state.projectName + " (Tagok)" },
                React.createElement(PieChart, { data: store.projectStatistics.userChartData }));
        var userTable = !store.hasStatistics ? null :
            React.createElement(BoardyCard, { title: this.state.projectName + " (Összesítő)" },
                React.createElement(UserTable, { users: store.projectStatistics.userStatistics, onSelection: this.handleUserSelection }));
        var user = !store.selectedUserSummary ? null :
            React.createElement(BoardyCard, { title: this.state.userName },
                React.createElement(StatisticTaskTable, { tasks: store.selectedUserSummary.statistic.spentByTasks.filter(function (i) { return i.projectName === _this.state.projectName; }) }));
        return (React.createElement(Main, null,
            React.createElement(SprintChooser, null),
            React.createElement("div", { className: "container" },
                projectChooser,
                taskChart,
                userChart,
                userTable,
                user)));
    };
    Summary.prototype.loadStatistics = function (selectedId) {
        this.props.projectStore.loadProjectStatistics(selectedId, this.props.taskStore.sprintIndex);
    };
    Summary = tslib_1.__decorate([
        inject('taskStore', 'projectStore'),
        observer
    ], Summary);
    return Summary;
}(React.Component));
export { Summary };



//////////////////
// WEBPACK FOOTER
// ./src/pages/statistics/Summary.tsx
// module id = 795
// module chunks = 0